import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const SliderMask = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    const maskClasses = classes.push('w-slider-mask');
    return (
      <div {...generateAttributes(attributes, maskClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Mask',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Slider'), iconName('Mask')),
  },
  showEmpty: true,
  constraints: {
    children: [
      {
        is: 'SliderSlide',
        name: 'Non-Slide Item',
        rule: 'RequireOnly',
      },
      {
        is: 'SliderSlide',
        rule: 'AtLeastOne',
      },
    ],
    pinToParent: true,
  },
  lockedStyles: {
    display: {
      when: true,
      message:
        'Disabled to preserve slider functionality. Add and style a div block if you need a different display setting for slider content.',
    },
  },
  render: SliderMask,
  fields: {children: TListOfElement},
});

export default config;
